module.exports = __webpack_public_path__ + "static/media/header_help.61af6381.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/header_help.jpg
// module id = 895
// module chunks = 0